import React, { useState } from "react"
import './index.css'
import search_icon from './Photos/search.png'
import clear_icon from './Photos/clear.png'
import drizzle_icon from './Photos/drizzle.png'
import cloud_icon from './Photos/cloud.png'
import humidity_icon from './Photos/humidity.png'
import rain_icon from './Photos/rain.png'
import snow_icon from './Photos/snow.png'
import wind_icon from './Photos/wind.png'

const Weather = () =>{
    let apikey='b74321f7c951a982f67e85136aa79ccf';

    const [wicon,setwicon]=useState(cloud_icon);

    const search = async () => {
        const element = document.getElementsByClassName("cityname");
        if (element[0].value === "") {
            return 0;
        }
        let url = `https://api.openweathermap.org/data/2.5/weather?q=${element[0].value}&units=Metric&appid=${apikey}`;
    
        try {
            let response = await fetch(url);
    
            if (response.ok) {
                let data = await response.json();
    
                const humidity = document.getElementsByClassName("humidity-perc");
                const temperature = document.getElementsByClassName("temp");
                const location = document.getElementsByClassName("location");
                const wind = document.getElementsByClassName("windd");
    
                humidity[0].innerHTML = data.main.humidity + " %";
                temperature[0].innerHTML = data.main.temp + " °C";
                location[0].innerHTML = data.name;
                wind[0].innerHTML = data.wind.speed + " Km/h";
    
                if (data.weather[0].icon === "01d" || data.weather[0].icon === "01n") {
                    setwicon(clear_icon);
                } else if (data.weather[0].icon === "02d" || data.weather[0].icon === "02n") {
                    setwicon(cloud_icon);
                } else if (data.weather[0].icon === "03d" || data.weather[0].icon === "03n") {
                    setwicon(drizzle_icon);
                } else if (data.weather[0].icon === "04d" || data.weather[0].icon === "04n") {
                    setwicon(drizzle_icon);
                } else if (data.weather[0].icon === "09d" || data.weather[0].icon === "09n") {
                    setwicon(rain_icon);
                } else if (data.weather[0].icon === "10d" || data.weather[0].icon === "10n") {
                    setwicon(rain_icon);
                } else if (data.weather[0].icon === "13d" || data.weather[0].icon === "13n") {
                    setwicon(snow_icon);
                } else {
                    setwicon(clear_icon);
                }
            } else {
                // Handle non-successful response (e.g., display an error message)
                console.error(`Error: ${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            console.error("An error occurred while fetching data:", error);
        }
    };
    
    return(
        <>
        <div className="container">
            <div className="top-bar">
                <input type="text" className="cityname" placeholder="Search"/>
                <div className="searchimg" onClick={()=>search()}>
                    <img src={search_icon} alt=""/>
                </div>
            </div>
            <div className="weatherimg">
                <img src={wicon} alt=""/>
            </div>
            <div className="temp">24°C</div>
            <div className="location">Algiers</div>
            <div className="datacontainer">
                <div className="element">
                    <img src={humidity_icon} alt="" />
                    <div className="data">
                        <div className="humidity-perc">64%</div>
                        <div className="text">Humidity</div>
                    </div>
                </div>
                <div className="element">
                    <div classname="dataimg">
                        <img src={wind_icon} alt="" />
                    </div>
                    <div className="data">
                        <div className="windd">18Km/h</div>
                        <div className="text">Humidity</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="footer">
            <h1>Made by Nova</h1>
        </div>
        </>
    );
}

export default Weather